import { createSelector } from '@reduxjs/toolkit';
const participantsRoot = state => state.participants;
export const meetingParticipantsSelector = createSelector(participantsRoot, ({
  participants
}) => participants);
export const isLoadingSelector = createSelector(participantsRoot, ({
  isLoading
}) => isLoading);
export const isGoogleOutageSelector = createSelector(participantsRoot, ({
  isGoogleOutage
}) => isGoogleOutage);